import { render } from "./program-list.vue?vue&type=template&id=a989da52"
import script from "./program-list.vue?vue&type=script&lang=js"
export * from "./program-list.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__